import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { StateComponent } from '../../../../../../common/components/state/state.component';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'oo-submit-form-dialog',
  templateUrl: './submit-form-dialog.component.html',
  styleUrls: ['./submit-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatCheckbox, FormsModule, MatDialogActions, MatButton],
})
export class SubmitFormDialogComponent extends StateComponent<SubmitFormDialogComponentState> implements OnInit {

  state: SubmitFormDialogComponentState = {
    notify: true,
  };
  private readonly dialogRef = inject<MatDialogRef<SubmitFormDialogComponent, SubmitFormDialogComponentReturnData>>(MatDialogRef);

  ngOnInit(): void {
    this.dialogRef.updateSize('400px', '300px');
    this.dialogRef.disableClose = true;
  }

  close(submit: boolean): void {
    this.dialogRef.close({
      submit,
      notify: this.state.notify,
    });
  }
}

interface SubmitFormDialogComponentState {
  notify: boolean;
}

export interface SubmitFormDialogComponentReturnData {
  submit: boolean;
  notify: boolean;
}
